export default __webpack_public_path__ + "static/media/profil.e87fa086.png";